import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { AdminToaster } from "@/components/ui/sonner";

/**
 * Tüm `/dekosta-yonetim/*` içeriğinde tek tip koyu arayüz (mevcut admin görünümü).
 * Çıkınca document html sınıfları temizlenir; public tema PublicThemeProvider ile yeniden uygulanır.
 */
export default function AdminSection() {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add("dark");
    root.setAttribute("data-theme", "dark");
    return () => {
      root.classList.remove("dark");
      root.removeAttribute("data-theme");
    };
  }, []);

  return (
    <>
      <Outlet />
      <AdminToaster />
    </>
  );
}
